




















































import Vue from 'vue'
import { Component, Emit, Inject, Prop } from 'vue-property-decorator'

import Input from '@/components/atoms/Input.vue'
import { Validator } from 'vee-validate'

import { ThreeDSecureExtraProfile } from './extra-profile'

export type ExtraProfileFormState = ThreeDSecureExtraProfile

export const emptyProfileFormState: () => ExtraProfileFormState = () => ({
  buyerNameKanji: '',
  buyerEmail: '',
  buyerTel: '',
})

@Component({
  components: {
    SpaInput: Input,
  },
})
export default class ExtraProfile extends Vue {
  @Inject()
  readonly $validator: Validator

  @Prop({
    required: true,
  })
  readonly value: ExtraProfileFormState

  get telValidation(): any {
    return {
      required: true,
      regex: /^\d[\d-]{6,11}\d$/, // 8-13桁の数字またはハイフン
    }
  }

  onInputNameKanji(value: string): void {
    this.onInput({
      ...this.value,
      buyerNameKanji: value,
    })
  }

  onInputEmail(value: string): void {
    this.onInput({
      ...this.value,
      buyerEmail: value,
    })
  }

  onInputTel(value: string): void {
    this.onInput({
      ...this.value,
      buyerTel: value,
    })
  }

  @Emit('input')
  onInput(_value: ExtraProfileFormState): void {
    // Do nothing
  }
}
